import { FavorableContent } from '@modules/favorites/interfaces/favorable-content.interface';
import { MediaAudioInterface } from '@modules/media/models/media-audio.model';
import { MediaDocumentInterface } from '@modules/media/models/media-document.model';
import { MediaImageInterface } from '@modules/media/models/media-image.model';
import { MediaTechnicalDataInterface } from '@modules/media/models/media-technical-data-model';
import { MediaVideoInterface } from '@modules/media/models/media-video.model';
import { TrackingItem } from '@modules/shared/gtm/data-layer.types';
import { DownloadableContent } from '@modules/shared/services/download.service';
import { SharableContent } from '@modules/shared/services/share.service';
import { ButtonItem } from '@modules/ui/action-container/action-container.component';

import { CardContentAlignment } from '../enums/card-content-alignment.enum';

import { CardLinkInterface } from './card-link.interface';

export const TARGET_NEW_SPECT = `
location=1,
status=1,
scrollbars=1,
resizable=1,
directories=1,
toolbar=1,
titlebar=1
`;

export interface CardInterface extends SharableContent, FavorableContent, DownloadableContent {
  icon?: string;
  topline?: string;
  text?: string;
  fuelLabel?: string;
  headline?: string;
  metaItems?: string[];
  link?: CardLinkInterface;
  translatableMetaItems?: { key: string; data: any }[];
  tags?: string[];
  isArchived?: boolean;
  metaItemsTop?: boolean;
  alignContent?: CardContentAlignment;
  media?:
    | MediaImageInterface
    | MediaVideoInterface
    | MediaAudioInterface
    | MediaDocumentInterface
    | MediaTechnicalDataInterface;
  actions?: ButtonItem[];
  type?: string;
  trackingData?: TrackingItem | undefined;
}
